import { useEffect, useState } from 'react';
import { Avatar, Card } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import { useLoaderData } from 'react-router-dom';
import { backendUrl } from '../../api/http';
import { round } from '../../utils/format';
import ActivityItem from '../activity/ActivityItem';
import '../activity/Activity.css';
import './Athlete.css';

export async function loader({ params }) {
  return { athleteId: params.athleteId };
}

export async function action() {}

function Athlete() {
  const { athleteId } = useLoaderData();
  const [activities, setActivities] = useState({ data: [], summary: { distance: 0 } });
  const [status, setStatus] = useState('loading');

  useEffect(() => {
    let ignore = false;

    async function loadAthleteActivities() {
      setStatus('loading');
      try {
        const response = await fetch(
          `${backendUrl}/api/strava-provider/athlete/${athleteId}/activity?pagination[page]=1&pagination[pageSize]=100`,
          {
            method: 'GET',
            mode: 'cors',
            cache: 'no-cache',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
          }
        );

        if (!response.ok) {
          throw new Error(`Request failed with status ${response.status}`);
        }

        const result = await response.json();
        if (!ignore) {
          setActivities(result);
          setStatus('ready');
        }
      } catch (err) {
        if (!ignore) setStatus('error');
      }
    }

    loadAthleteActivities();
    return () => {
      ignore = true;
    };
  }, [athleteId]);

  if (status === 'loading') {
    return <div className="htv-state">Đang tải hồ sơ vận động viên...</div>;
  }

  if (status === 'error') {
    return <div className="htv-state">Không tải được dữ liệu vận động viên.</div>;
  }

  const totalDistance = activities?.summary?.distance || 0;
  const activityCount = activities?.data?.length || 0;

  return (
    <section className="athlete-page">
      <Card className="athlete-hero htv-card">
        <div className="athlete-identity">
          <Avatar size={72} icon={<UserOutlined />} />
          <div>
            <p className="htv-muted">Hồ sơ công khai</p>
            <h1>Vận động viên #{athleteId}</h1>
          </div>
        </div>
        <div className="athlete-stat-grid">
          <div>
            <strong>{round(totalDistance / 1000)} km</strong>
            <span>Tổng quãng đường</span>
          </div>
          <div>
            <strong>{activityCount}</strong>
            <span>Hoạt động</span>
          </div>
        </div>
      </Card>

      {activityCount ? (
        <div className="activity-grid">
          {activities.data.map((activity, index) => (
            <ActivityItem activity={activity} key={activity.id || index} />
          ))}
        </div>
      ) : (
        <div className="htv-state">Vận động viên này chưa có hoạt động được đồng bộ.</div>
      )}
    </section>
  );
}

export default Athlete;
